import { apiFetch } from './api';

export const loginService = (email, password) =>
  apiFetch('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) });

export const registerService = (email, password, name) =>
  apiFetch('/auth/register', { method: 'POST', body: JSON.stringify({ email, password, name }) });
